// Make labels a flex item showing prices to the right
document.addEventListener('DOMContentLoaded', () => {
  const labels = document.querySelectorAll('.wpcf7-list-item-label');

  labels.forEach((label) => {
    const text = label.textContent.trim();

    // Match title + (price), e.g., "Aiandi hoovis katusega (40 € /kuu)"
    const match = text.match(/^(.+?)\s*\((.+?)\)$/);
    if (match) {
      const title = match[1].trim();
      const price = match[2].trim();

      // Clear and rebuild the label
      label.textContent = '';

      const titleSpan = document.createElement('span');
      titleSpan.textContent = title;

      const priceSpan = document.createElement('span');
      priceSpan.textContent = ` ${price}`;
      priceSpan.classList.add('option-price');
      priceSpan.style.whiteSpace = 'nowrap';

      label.appendChild(titleSpan);
      label.appendChild(priceSpan);
    }
  });
});

if (document.body.classList.contains('page-template-uurimise-avaldus-php')) {
  // Your uncheckGroup logic here
  document.addEventListener('DOMContentLoaded', function () {
    const baseRent = parseFloat(window.rentDiscountPrice) || parseFloat(window.rentPrice); // if is discounted then use discount, if not use regular
    
    if (isNaN(baseRent)) {
      console.warn('window.rentPrice || window.rentDiscountPrice is not a valid number.');
      return;
    }

    const rendinPayment = baseRent * 0.04;

    const rendintarget = document.getElementById(
      'rendin-calculated-monthly-payment'
    );
    if (rendintarget) {
      rendintarget.textContent = `${rendinPayment.toFixed(1)}`;
    } else {
      // console.warn('#rendin-calculated-monthly-payment element not found.');
    }

    const pricetarget = document.getElementById('regular-calculated-payment');
    if (pricetarget) {
      pricetarget.textContent = `${baseRent.toFixed(0) * 2}`;
    } else {
      // console.warn('#regular-calculated-payment element not found.');
    }
  });

  // Extra services options, making them show up on mobile summary card and desktop card

  document.addEventListener('DOMContentLoaded', function () {
    const groups = [
      'group-storage-space',
      'group-bike-storage',
      'group-trolley-storage',
      'group-parking',
      'group-electric-parking',
      'group-motorbike-parking'
    ];

    const groupElements = {}; // will store { element, inputs[] }
    const allInputs = [];
    const selectedValues = {};
    let parkingCount = 1;

    groups.forEach((groupId) => {
      const groupEl = document.querySelector(
        '[data-orig_data_id="' + groupId + '"]'
      );

      if (groupEl) {
        const inputs = Array.from(
          groupEl.querySelectorAll(
            'input[type="radio"], input[type="checkbox"]'
          )
        );

        groupElements[groupId] = {
          element: groupEl,
          inputs: inputs,
        };

        allInputs.push(...inputs);
        // none selected individually
        selectedValues[groupId] = null;

        // Add change event to track selection
        inputs.forEach((input) => {
          input.addEventListener('change', () => {
            if (input.checked) {
              if (input.name == 'parking_count') {
                parkingCount = parseInt(input.value.split(' ')[0]) || 1;
              } else {
                const parsed = parseValue(input.value);
                selectedValues[groupId] = parsed;
              }
            } else {
              // for checkboxes, remove if unchecked
              const type = input.type;
              if (type === 'checkbox') {
                selectedValues[groupId] = null; // You could use an array for multi-select
              }
            }
            updateDOM();
          });
        });
      }
    });

    // ✅ Uncheck all inputs
    function uncheckAll() {
      Object.keys(selectedValues).forEach((groupId) => {
        selectedValues[groupId] = null;
      });

      allInputs.forEach((input) => {
        input.checked = false;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        updateDOM();
      });
    }

    // ✅ Uncheck a specific group
    function uncheckGroup(groupId) {
      const group = groupElements[groupId];
      if (!group) {
        console.warn(`Group "${groupId}" not found.`);
        return;
      }

      selectedValues[groupId] = null;

      group.inputs.forEach((input) => {
        if (input.name !== 'parking_count') {
          input.checked = false;
        }
        input.dispatchEvent(new Event('change', { bubbles: true }));
        updateDOM();
      });
    }

    function parseValue(value) {
      // Example: "Aiandi väike panipaik (10 € /kuu)" -> "Aiandi väike panipaik" "10"
      const match = value.match(/^(.+?)\s*\(([\d\s]+)€/);
      if (match) {
        return {
          name: match[1].trim(),
          price: parseFloat(match[2].trim()),
        };
      }
      return { name: value, price: null };
    }

    function updateDOM() {
      const containers = document.querySelectorAll('.selected-services-summary');
      const template = document.querySelector('.service-template');

      // Clear everything
      containers.forEach(container => container.innerHTML = '');

      let hasAnySelected = false;

      // Loop through selectedValues and render
      Object.entries(selectedValues).forEach(([groupId, service]) => {
        if (!service || !service.name || !service.price) return;

        hasAnySelected = true;

        const clone = template.content.cloneNode(true);
        const wrapper = clone.querySelector('.selected-service');

        if (wrapper) {
          wrapper.dataset.key = service.key;

          const nameEl = wrapper.querySelector('.service-name');
          if (nameEl) nameEl.textContent = service.name;

          const priceEl = wrapper.querySelector('.service-price');
          if (priceEl && groupId === 'group-parking' && parkingCount > 1) {
            if (priceEl)
              priceEl.textContent = `${service.price * parkingCount}\u00A0 €`;
          } else {
            if (priceEl) priceEl.textContent = `${service.price}\u00A0 €`;
          }

          const countEl = wrapper.querySelector('.service-count');
          if (countEl && groupId === 'group-parking' && parkingCount > 1) {
            countEl.textContent = ` × ${parkingCount}`;
          }
        }

        containers.forEach(container => {
          container.appendChild(clone.cloneNode(true));
        });
      });

      document.querySelectorAll('.hide-if-none').forEach((el) => {
        el.classList.toggle('!hidden', !hasAnySelected);
      });

      updateContractTotal();
    }

    function updateContractTotal() {
      const basePrice = parseFloat(window.rentDiscountPrice) || parseFloat(window.rentPrice) || 0;
      const amenetiesPrice = parseFloat(window.amenetiesPrice) || 0;

      const serviceTotal = Object.entries(selectedValues).reduce(
        (sum, [groupId, service]) => {
          if (!service || !service.price) return sum;
          const count = groupId === 'group-parking' ? parkingCount : 1;
          return sum + parseFloat(service.price) * count;
        },
        0
      );

      const total = basePrice + serviceTotal + amenetiesPrice;

      document.querySelectorAll('.contract-total').forEach((el) => {
        el.textContent = `${total.toFixed(0)} €`;
      });
    }

    // Uncheck when main is unchecked
    const checkboxGroupMap = {
      'selected-services-storage-space[]': 'group-storage-space',
      'selected-services-bike-storage[]': 'group-bike-storage',
      'selected-services-trolley-storage[]': 'group-trolley-storage',
      'selected-services-parking[]': 'group-parking',
      'selected-services-electric-parking[]': 'group-electric-parking',
      'selected-services-motorbike-parking[]': 'group-motorbike-parking'
    };

    function clearRadioValidation(input) {
      const wrap = input.closest('.wpcf7-form-control-wrap');

      if (!wrap) return;

      wrap.querySelectorAll(`input[name="${input.name}"]`).forEach((radio) => {
        radio.classList.remove('wpcf7-not-valid');
        radio.setAttribute('aria-invalid', 'false');
        radio.removeAttribute('aria-describedby');
      });

      wrap.querySelectorAll('.wpcf7-not-valid-tip').forEach((tip) => {
        tip.remove();
      });
    }

    function selectSingleRadioDefault(groupId) {
      const group = groupElements[groupId];
      if (!group) return;

      const radios = group.inputs.filter((i) => i.type === 'radio');

      if (radios.length !== 1 || radios[0].checked) return;

      const onlyRadio = radios[0];
      onlyRadio.checked = true;
      selectedValues[groupId] = parseValue(onlyRadio.value);
      clearRadioValidation(onlyRadio);
      onlyRadio.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function selectServiceDefaults(groupId) {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          if (groupId === 'group-parking') {
            selectFirstParkingDefaults();
            return;
          }

          selectSingleRadioDefault(groupId);
        });
      });
    }

    // Attach listener to all checkboxes
    Object.keys(checkboxGroupMap).forEach((inputName) => {
      const groupId = checkboxGroupMap[inputName];

      document
        .querySelectorAll(`input[name="${inputName}"]`)
        .forEach((input) => {
          input.addEventListener('change', () => {
            const allCheckboxes = document.querySelectorAll(
              `input[name="${inputName}"]`
            );
            const allUnchecked = Array.from(allCheckboxes).every(
              (cb) => !cb.checked
            );

            if (allUnchecked) {
              uncheckGroup(groupId);
            } else {
              selectServiceDefaults(groupId);
            }

          });
        });

      const anyChecked = Array.from(
        document.querySelectorAll(`input[name="${inputName}"]`)
      ).some((checkbox) => checkbox.checked);

      if (anyChecked) {
        selectServiceDefaults(groupId);
      }
    });

    function selectFirstParkingDefaults() {
      const groupId = 'group-parking';
      const group = groupElements[groupId];
      if (!group) return;

      // Radios that choose the actual parking product (exclude the count radios)
      const serviceRadios = group.inputs.filter(
        (i) => i.type === 'radio' && i.name !== 'parking_count'
      );
      // Radios that choose how many parking spots
      const countRadios = group.inputs.filter(
        (i) => i.type === 'radio' && i.name === 'parking_count'
      );

      // 1) Ensure a service radio is selected
      const anyServiceChecked = serviceRadios.some((r) => r.checked);
      if (serviceRadios.length && !anyServiceChecked) {
        const firstService = serviceRadios[0];
        firstService.checked = true;
        selectedValues[groupId] = parseValue(firstService.value);
        clearRadioValidation(firstService);
        firstService.dispatchEvent(new Event('change', { bubbles: true }));
      }

      // 2) Ensure a parking_count radio is selected
      const anyCountChecked = countRadios.some((r) => r.checked);
      if (countRadios.length && !anyCountChecked) {
        const firstCount = countRadios[0];
        firstCount.checked = true;
        clearRadioValidation(firstCount);
        firstCount.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  });
}
